import styled from "styled-components";

import { NavLink } from "react-router-dom";
import { Dialog } from "primereact/dialog";

export const Container = styled.div.attrs({
  "data-testid": "top-header",
} as Record<string, string>)`
  background: ${({ theme }) => theme.bg.bg1};
  border-bottom: 1px solid #e7e7e7;
  padding: 5.9px 32px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  position: sticky;
  top: 0;
  z-index: 100;
  align-items: center;
  flex-wrap: wrap;
  flex: 0 0 auto;
`;

export const LogoContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  flex-direction: row;
  justify-content: space-between;
`;

export const Avatar = styled.div`
  background: ${({ theme }) => theme.sidebarHeader.background1};
  width: 48px;
  height: 48px;
  color: ${({ theme }) => theme.sidebarHeader.text1};
  border-radius: 50%;
  text-align: center;
  padding: 12px 0;
  font-weight: 600;
  font-size: 16.8px;
  align-self: center;
  cursor: pointer;
`;

export const Avatar2 = styled.div`
  background: ${({ theme }) => theme.sidebarHeader.menu.avatarBg};
  width: 64px;
  height: 64px;
  color: ${({ theme }) => theme.sidebarHeader.menu.avatarText};
  border-radius: 50%;
  text-align: center;
  padding: 12px 0;
  font-weight: 600;
  font-size: 16.8px;
  align-self: center;
  cursor: pointer;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const AvatarImg = styled.img`
  width: 48px;
  height: 48px;
  border-radius: 50%;
  cursor: pointer;
`;

export const Popover = styled.div`
  width: 250px;
  background-color: ${({ theme }) => theme.sidebarHeader.menu.bg};
  border: 1px solid ${({ theme }) => theme.sidebarHeader.menu.border};
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  text-align: center;
  padding: 16px;
  position: absolute;
  right: 0;
  z-index: 999;

  & img {
    width: 64px;
    height: 64px;
  }
`;

export const PopoverContainer = styled.div`
  position: relative;
`;

export const Name = styled.span`
  font-weight: 600;
  font-size: 16px;
  line-height: 22px;
  text-align: center;
  color: ${({ theme }) => theme.sidebarHeader.menu.text};
`;

export const MenuItem = styled(NavLink)`
  padding: 8px;
  text-decoration: none;
  border-radius: 4px;
  margin: 0 0 10px 0;
  text-align: left;
  color: #181818;
  display: inline-block;

  &:visited {
    color: #181818;
  }

  &:hover {
    background: #ebf4ff;
  }

  & span {
    font-size: 14px;
    font-weight: 500;
    line-height: 19px;
    color: black;

    &:hover {
      color: #065fa6;
    }
  }

  & svg {
    position: relative;
    top: 4px;
    margin-right: 12px;
  }
`;

export const MenuContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  flex: 1 1;
`;

export const MenuItem2 = styled.div`
  padding: 8px;
  text-decoration: none;
  border-radius: 4px;
  margin: 0 0 10px 0;
  text-align: left;
  color: ${({ theme }) => theme.sidebarHeader.menu.text};
  display: inline-block;

  &:hover {
    background: ${({ theme }) => theme.sidebarHeader.menu.active};
  }

  & span {
    font-size: 14px;
    font-weight: 500;
    line-height: 19px;
    color: black;

    &:hover {
      color: #065fa6;
    }
  }

  & svg {
    position: relative;
    top: 4px;
    margin-right: 12px;
  }
`;

export const Title = styled.h1`
  font-weight: 600;
  font-size: 24px;
  line-height: 32px;
  color: ${({ theme }) => theme.sidebarHeader.menu.text};
  margin-top: 16px;
`;

export const Text = styled.p`
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
  color: ${({ theme }) => theme.sidebarHeader.menu.text};
  margin-top: 16px;
`;

export const SupportLink = styled.a`
  font-weight: 600;
  font-size: 16px;
  line-height: 22px;
  text-decoration: underline;
  color: ${({ theme }) => theme.sidebarHeader.menu.text};
`;

export const DialogWrapper = styled.div`
  margin: 0 32px 32px 32px;
`;

export const LogoutTitle = styled.h2`
  font-weight: 600;
  font-size: 24px;
  line-height: 32px;
  color: ${({ theme }) => theme.sidebarHeader.menu.text};
`;

export const Controls = styled.div`
  display: flex;
  flex-direction: row;
  gap: 12px;
  margin-top: 32px;
  justify-content: flex-end;
`;

export const CancelLogoutBtn = styled.button`
  border: 1.5px solid #065fa6;
  background: #ffffff;
  border-radius: 6px;
  padding: 8px 20px;
  font-size: 16px;
  line-height: 22px;
  font-weight: 600;
  color: #065fa6;
  cursor: pointer;

  &:hover {
    border: 1.5px solid #181818;
    color: #181818;
  }
`;

export const LogOutBtn = styled.button`
  border-radius: 6px;
  background: #065fa6;
  padding: 8px 20px;
  color: #ffffff;
  font-size: 16px;
  line-height: 22px;
  font-weight: 600;
  cursor: pointer;
  border: none;

  &:hover {
    background: #181818;
  }
`;

export const ThemedDialog = styled(Dialog)`
  & .p-dialog-content,
  & .p-dialog-header {
    background-color: ${({ theme }) => theme.sidebarHeader.menu.dialog.bg};
  }

  & .p-dialog-header {
    padding: 32px 32px 0px 32px;
  }

  & .p-dialog-header-icons button {
    color: ${({ theme }) => theme.sidebarHeader.menu.text};

    &:hover {
      background-color: ${({ theme }) => theme.sidebarHeader.menu.dialog.bg};
    }
  }
`;

export const Tag = styled.div`
  background: #ebf4ff;
  color: #065fa6;
  font-weight: 500;
  font-size: 16px;
  line-height: 22px;
  padding: 2px 8px;
  border-radius: 100px;
`;

export const InnerMenuContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 32px;
`;

export const MenuItems = styled.div`
  display: flex;
  flex-direction: row;
  gap: 32px;
  justify-content: space-between;

  & a {
    text-decoration: none;
    color: #181818;
    font-size: 16px;
    font-weight: 500;
    line-height: 22px;

    &:hover {
      color: #065fa6;
    }
  }
`;

export const DropdownWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 24px;
`;
